import { createContext, useContext } from 'react';
import { type APIs } from '../core/api';
import { type NavigationAdapter } from './navigation/NavigationAdapter';
import { type AppOpenerAdapter } from './app-opener/AppOpenerAdapter';
import { type IframeAdapter } from './iframe/IframeAdapter';
import { type DeviceAdapter } from './device/DeviceAdapter';

export interface Platform {
  apis: APIs;
  navigation: NavigationAdapter;
  appOpener: AppOpenerAdapter;
  iframe: IframeAdapter;
  device: DeviceAdapter;
}

export const PlatformContext = createContext<Platform | null>(null);

export const usePlatform = (): Platform => {
  const values = useContext(PlatformContext);
  if (values === null) {
    throw new Error('PlatformContext not initialized');
  }
  return values;
};
